export const colors = {
  white: "#FFFFFF",
  dark: "#282828",
  borderGray: "#AFAFAF",

  text: {
    primary: "#656565",
    secondary: "#282828",
    contrast: "#FFFFFF",
    success: "#17B26A",
    error: "#F04438",
  },

  brand: {
    primary: "#004BB9",
    primaryHover: "rgba(0, 0, 0, 0.8)",
  },
};
